/* batida-v7-lookbook.js (Lookbooki, 28.09): the "Z sesji" photo strip (arrows + keyboard) and the lookbook switcher bar.
   - Arrows scroll the strip by one photo; they switch off at the ends and hide when everything fits.
   - The strip itself is focusable: ←/→ move by one photo, Home/End jump to the ends.
   - The bar shows the current lookbook's tab even when the tabs scroll sideways (phones).
   Works with the theme editor (sections re-rendered in place). Loaded by sections/batida-v7-lookbook-bar.liquid. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function trackOf(film) { return film && film.querySelector('.v7lb-film__track'); }

  function stepOf(track) {
    var items = track.children, i, it;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (it.offsetWidth > 0) {
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return it.offsetWidth + gap;
      }
    }
    return track.clientWidth * 0.8;
  }

  function update(film) {
    var track = trackOf(film);
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var prev = film.querySelector('[data-v7lb-dir="-1"]');
    var next = film.querySelector('[data-v7lb-dir="1"]');
    film.classList.toggle('no-scroll', max <= 2);
    // aria-disabled (not disabled): a button that reaches the end keeps keyboard focus
    if (prev) prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
    if (next) next.setAttribute('aria-disabled', track.scrollLeft >= max - 2 ? 'true' : 'false');
  }

  function go(film, dir) {
    var track = trackOf(film);
    if (!track) return;
    track.scrollBy({ left: dir * stepOf(track), behavior: reduce ? 'auto' : 'smooth' });
  }

  function initBars(root) {
    (root || document).querySelectorAll('.v7lb-bar').forEach(function (bar) {
      var on = bar.querySelector('.v7lb-pill.is-on');
      if (!on) return;
      [on.closest('.v7lb-bar__tabs'), on.closest('.v7lb-bar__in')].forEach(function (box) {
        if (!box || box.scrollWidth <= box.clientWidth + 1) return;
        var bl = box.getBoundingClientRect().left, r = on.getBoundingClientRect();
        var right = r.right - bl + box.scrollLeft + 20;
        if (right > box.scrollLeft + box.clientWidth) box.scrollLeft = right - box.clientWidth;
      });
    });
  }

  // How far the theme's header hangs over #MainContent (only measurable while it is not stuck).
  function tuck() {
    var sec = document.querySelector('.v7lb-barsec');
    var hdr = document.querySelector('.theme__header');
    var wrap = document.querySelector('.header__wrapper');
    var main = document.getElementById('MainContent');
    if (!sec || !hdr || !main || window.scrollY > 5 || (wrap && wrap.classList.contains('js__header__stuck'))) return;
    var d = Math.round(hdr.getBoundingClientRect().bottom - main.getBoundingClientRect().top);
    if (d >= 0 && d < 80) document.documentElement.style.setProperty('--lb-bar-tuck', d + 'px');
  }

  function init(root) {
    (root || document).querySelectorAll('[data-v7lb-film]').forEach(update);
    initBars(root);
    tuck();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-v7lb-dir]');
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    go(b.closest('[data-v7lb-film]'), +b.getAttribute('data-v7lb-dir'));
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('v7lb-film__track')) return;
    var film = t.closest('[data-v7lb-film]');
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      go(film, e.key === 'ArrowRight' ? 1 : -1);
    } else if (e.key === 'Home' || e.key === 'End') {
      e.preventDefault();
      t.scrollTo({ left: e.key === 'Home' ? 0 : t.scrollWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  var timer;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('v7lb-film__track')) return;
    clearTimeout(timer);
    timer = setTimeout(function () { update(t.closest('[data-v7lb-film]')); }, 60);
  }, true);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { document.documentElement.style.removeProperty('--lb-bar-tuck'); init(); }, 150);
  });
  window.addEventListener('load', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
